import { render, staticRenderFns } from "./B2BReportList.vue?vue&type=template&id=2732bdb7&scoped=true"
import script from "./B2BReportList.vue?vue&type=script&lang=js"
export * from "./B2BReportList.vue?vue&type=script&lang=js"
import style0 from "./B2BReportList.vue?vue&type=style&index=0&id=2732bdb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2732bdb7",
  null
  
)

export default component.exports